/* Luxmi product-card image carousel — dots + swipe + hover cycle.
   Attaches once on DOMContentLoaded; skips carousels it has already wired. */

(function () {
  var HOVER_DELAY = 700; // ms per image while hovering

  function wire(root) {
    if (root.__luxMcWired) return;
    root.__luxMcWired = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.lux-mc__slide'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('.lux-mc__dot'));
    if (slides.length < 2) return;
    var current = 0;
    var hoverTimer = null;

    function go(i) {
      i = ((i % slides.length) + slides.length) % slides.length;
      if (i === current) return;
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      dots[current].setAttribute('aria-selected', 'false');
      current = i;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-selected', 'true');
    }

    // Dots.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        // Stop the parent card link from being followed.
        e.preventDefault();
        e.stopPropagation();
        go(i);
      });
    });

    // Hover: cycle every HOVER_DELAY ms while pointer stays inside.
    function startHover() {
      root.setAttribute('data-hovering', '1');
      clearInterval(hoverTimer);
      hoverTimer = setInterval(function () { go(current + 1); }, HOVER_DELAY);
    }
    function stopHover() {
      root.removeAttribute('data-hovering');
      clearInterval(hoverTimer);
      hoverTimer = null;
      // Return to the first image when the pointer leaves so cards stay
      // consistent at rest.
      go(0);
    }
    root.addEventListener('mouseenter', startHover);
    root.addEventListener('mouseleave', stopHover);

    // Touch: horizontal swipe.
    var startX = null;
    var tracking = false;
    root.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      startX = e.touches[0].clientX;
      tracking = true;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - startX;
      if (Math.abs(dx) > 30) {
        // Stop the tap from navigating to the PDP after a swipe.
        e.preventDefault();
        go(current + (dx < 0 ? 1 : -1));
      }
    });
  }

  function scan() {
    document.querySelectorAll('.lux-mc').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan when new cards are inserted (e.g. Shopify section reload in editor).
  document.addEventListener('shopify:section:load', scan);
})();
